'use strict';

/**
 * Header search and «kortkode» (short code) behaviour that is not the suggestions themselves (assets/search-suggest.js).
 *
 * Mobile: two round buttons sit on the line under the top bar, a # (kortkode) a little left of centre and a magnifier
 * a little right of centre. Tapping one slides both to the centre (the tapped one on top, the other tucks behind it and
 * fades out), then the header extends (animated) with that button's pane. The tapped button shows an X; the X reverses
 * the whole sequence. Esc closes (after the suggestions). Opening the navigation drawer closes it, and vice versa.
 * Desktop: the # button in the top bar opens a small popover with the same form; the search field lives in the bar.
 * Also: the clear button on search fields, «/» focuses the search, and the kortkode form goes to <root>k/<code>.
 */
(function () {
  var drawer = document.querySelector('[data-hd-drawer]');
  var actions = document.querySelector('[data-hd-actions]');
  var toggles = [].slice.call(document.querySelectorAll('[data-hd-toggle]'));
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var DUR = 250;
  var topBar = document.querySelector('.site-top');
  var state = 'closed'; // closed | search | code | closing
  var timers = [];

  function dur() { return reduced && reduced.matches ? 0 : DUR; }
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function pane(which) { return drawer && drawer.querySelector('[data-hd-pane="' + which + '"]'); }
  function toggleFor(which) { return toggles.filter(function (t) { return t.getAttribute('data-hd-toggle') === which; })[0]; }
  function isDrawerOpen() { return state === 'search' || state === 'code'; }

  function setAria(which, open) {
    var t = toggleFor(which);
    if (!t) return;
    t.setAttribute('aria-expanded', String(open));
    var label = t.getAttribute(open ? 'data-label-close' : 'data-label-open');
    if (label) t.setAttribute('aria-label', label);
  }

  function open(which) {
    if (state !== 'closed' || !drawer || !actions || !pane(which)) return;
    clearTimers();
    state = which;
    document.dispatchEvent(new CustomEvent('site-nav:close'));
    setAria(which, true);
    ['search', 'code'].forEach(function (w) { var p = pane(w); if (p) p.hidden = w !== which; });
    actions.setAttribute('data-state', which); // buttons slide to the centre
    later(function () {
      drawer.classList.add('is-open'); // then the header extends
      var field = pane(which).querySelector('input[type=search], input[type=text]');
      if (field) field.focus({ preventScroll: true });
      later(function () { if (isDrawerOpen()) drawer.classList.add('is-settled'); }, dur() + 50);
    }, dur());
  }

  function close(returnFocus) {
    if (!isDrawerOpen()) return;
    var which = state;
    clearTimers();
    state = 'closing';
    drawer.classList.remove('is-settled');
    drawer.classList.remove('is-open'); // the header retracts first
    [].slice.call(drawer.querySelectorAll('[data-search-suggest]')).forEach(function (w) { w.dispatchEvent(new CustomEvent('suggest:close')); });
    setAria(which, false);
    later(function () {
      actions.setAttribute('data-state', 'closed'); // then the buttons slide apart
      ['search', 'code'].forEach(function (w) { var p = pane(w); if (p) p.hidden = true; });
      state = 'closed';
      if (returnFocus) { var t = toggleFor(which); if (t) t.focus(); }
    }, dur());
  }

  toggles.forEach(function (t) {
    t.addEventListener('click', function () {
      var which = t.getAttribute('data-hd-toggle');
      if (state === which) close(true);
      else open(which);
    });
  });

  if (drawer) {
    // Escape closes the suggestions first, the drawer second. The suggestions' own handler (on the input) runs before
    // this one in the bubble phase, so the state before the key press is read in the capture phase.
    var suggestionsWereOpen = false;
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var panel = drawer.querySelector('[data-suggest-panel]');
      suggestionsWereOpen = !!panel && !panel.hidden;
    }, true);
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isDrawerOpen() || suggestionsWereOpen) return;
      close(true);
    });
  }

  // Only one of the drawer and the navigation drawer at a time (assets/site-nav.js sends site-nav:open).
  document.addEventListener('site-nav:open', function () { close(false); });

  // Desktop: kortkode popover under the # button in the top bar.
  var kcToggle = document.querySelector('[data-kc-toggle]');
  var kcPop = document.querySelector('[data-kc-popover]');
  if (kcToggle && kcPop) {
    var kcSet = function (open, focusBack) {
      kcPop.hidden = !open;
      kcToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        document.dispatchEvent(new CustomEvent('site-nav:close'));
        var f = kcPop.querySelector('input'); if (f) f.focus();
      } else if (focusBack) kcToggle.focus();
    };
    kcToggle.addEventListener('click', function () { kcSet(kcPop.hidden, true); });
    kcPop.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); kcSet(false, true); } });
    document.addEventListener('click', function (e) { if (!kcPop.hidden && !kcPop.contains(e.target) && !kcToggle.contains(e.target)) kcSet(false, false); });
    document.addEventListener('site-nav:open', function () { if (!kcPop.hidden) kcSet(false, false); });
    var kcWrap = kcToggle.parentElement;
    kcWrap.addEventListener('focusout', function (e) { if (!kcPop.hidden && e.relatedTarget && !kcWrap.contains(e.relatedTarget)) kcSet(false, false); });
  }

  // The height of the bar (its first row, so the mobile drawer opening does not count) as --site-top-h, used to pull the first
  // content behind the header when «Innholdet starter bak headeren» is on.
  if (topBar) {
    var topRow = topBar.querySelector(':scope > .container');
    var measure = function () {
      if (topRow) document.documentElement.style.setProperty('--site-top-h', (topRow.offsetHeight + 1) + 'px');
    };
    measure();
    if (window.ResizeObserver && topRow) new ResizeObserver(measure).observe(topRow);
    window.addEventListener('resize', measure);
  }

  // The top bar gets data-scrolled once the page has moved (soft shadow in the mobile trial style).
  if (topBar) {
    var onScroll = function () { topBar.toggleAttribute('data-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Kortkode form: trim, drop spaces, lower case, go to <root>k/<code>.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-shortcode-form')) return;
    e.preventDefault();
    var input = form.querySelector('.kc-input');
    var error = form.querySelector('.kc-error');
    var code = (input.value || '').replace(/\s+/g, '').toLowerCase();
    if (!code) {
      input.setAttribute('aria-invalid', 'true');
      if (error) error.hidden = false;
      input.focus();
      return;
    }
    window.location.href = (form.getAttribute('data-path') || '/k/') + encodeURIComponent(code);
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('kc-input')) {
      t.removeAttribute('aria-invalid');
      var err = t.closest('form').querySelector('.kc-error');
      if (err) err.hidden = true;
    }
  });

  // Clear button on the search fields.
  [].slice.call(document.querySelectorAll('[data-search-clear]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-search-suggest]');
      var input = wrap && wrap.querySelector('input[type=search]');
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  });

  // «/» focuses the search.
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var mobileToggle = toggleFor('search');
    // Mobile: the field lives in the drawer, so open it. Desktop: focus the field in the top bar.
    if (mobileToggle && mobileToggle.offsetParent !== null) {
      e.preventDefault();
      if (state === 'closed') open('search');
      else if (state === 'search') { var f = pane('search').querySelector('input[type=search]'); if (f) f.focus(); }
      return;
    }
    var input = document.querySelector('[data-search-desktop] input[type=search]');
    if (input) { e.preventDefault(); input.focus(); input.select(); }
  });
})();
